import { patchRequest } from '../utils'

interface UpdateElementLabelDTO {
  label: string
}

export const updateElementLabel: RequestTypeVariable = {
  getKey: (projectId: string, elementGuid: string) => [
    'updateElementLabel',
    projectId,
    elementGuid,
  ],
  request: async (
    projectId: string,
    elementGuid: string,
    payload: UpdateElementLabelDTO,
  ): Promise<void> => {
    await patchRequest<void>({
      url: `/projects/${projectId}/planar-model/elements/${elementGuid}/label`,
      data: payload,
    })
  },
}
